import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Typography, ButtonGroup, Button, Box, TextField, Select, MenuItem } from '@mui/material';
import html2canvas from 'html2canvas';
function Builder() {
    const [heroes, setHeroes] = useState([]);
    const [maps, setMaps] = useState([]);
    const [selectedMap, setSelectedMap] = useState('');
    const [subMapName, setSubMapName] = useState('');
    const [mode, setMode] = useState('');
    const [pointNumber, setPointNumber] = useState('');
    const [teamAlly, setTeamAlly] = useState({ tank: [], damage: [], support: [] });
    const [teamEnemy, setTeamEnemy] = useState({ tank: [], damage: [], support: [] });
    const [teamAllyName, setTeamAllyName] = useState("Team 1"); // Nouveau
    const [teamEnemyName, setTeamEnemyName] = useState("Team 2"); // Nouveau
    const maxHeroes = { tank: 1, damage: 2, support: 2 };
    const [allyPlayerNames, setAllyPlayerNames] = useState({});
    useEffect(() => {
        // Faites votre appel API pour récupérer les héros
        axios.get('https://overfast-api.tekrop.fr/heroes')
            .then(response => {
                // Assurez-vous que chaque héros a une propriété 'portrait' qui est juste l'URL de l'image
                const heroesWithPortraits = response.data.map(hero => ({
                    ...hero, // Reprenez toutes les propriétés existantes du héros
                    portrait: hero.portrait // Utilisez l'URL de l'image directement
                }));
                setHeroes(heroesWithPortraits); // Mettez à jour l'état avec les héros récupérés
            })
            .catch(error => {
                console.error("Erreur lors de la récupération des héros:", error);
            });
        axios.get('https://overfast-api.tekrop.fr/maps')
            .then(response => setMaps(response.data))
            .catch(error => console.error("Erreur lors de la récupération des cartes:", error));
    }, []);
    const handleMapChange = (event) => {
        setSelectedMap(event.target.value);
    };
    const handleModeChange = (event) => {
        setMode(event.target.value);
    };
    const handlePlayerNameChange = (role, index, newName) => {
        setTeamAlly(currentTeams => {
            const newHeroes = [...currentTeams[role]];
            newHeroes[index] = { ...newHeroes[index], playerName: newName };
            return { ...currentTeams, [role]: newHeroes };
        });
    };
    const handlePointNumberChange = (event) => {
        setPointNumber(event.target.value);
    };
    // Trouver la carte sélectionnée basée sur selectedMap
    const currentMap = maps.find(map => map.name === selectedMap) || {};
    const handleSelectHero = (hero, teamType) => {
        const team = teamType === 'ally' ? teamAlly : teamEnemy;
        if (team[hero.role].length < maxHeroes[hero.role]) {
            const updatedTeam = {
                ...team,
                [hero.role]: [...team[hero.role], hero]
            };
            if (teamType === 'ally') {
                setTeamAlly(updatedTeam);
            } else {
                setTeamEnemy(updatedTeam);
            }
        } else {
            console.error(`Limite atteinte pour le rôle ${hero.role}`);
        }
    };
    const handleRemoveHero = (hero, teamType) => {
        const team = teamType === 'ally' ? teamAlly : teamEnemy;
        const updatedTeam = {
            ...team,
            [hero.role]: team[hero.role].filter((h) => h.name !== hero.name)
        };

        if (teamType === 'ally') {
            setTeamAlly(updatedTeam);
        } else {
            setTeamEnemy(updatedTeam);
        }
    };
    const teamRef = useRef(null); // Ajoutez une ref pour cibler la zone des équipes


    return (
        <>
            {/* <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, mt: 3 }}>
                <Button sx={{ backgroundColor: '#e4611c', color: 'white', fontFamily: 'Kanit, sans-serif', border: '2px solid transparent', padding: '10px', fontSize: '18px', transition: 'all 0.15s ease-in-out', "&:hover": { backgroundColor: '#e4611c', border: 'solid 2px white', borderRadius: '5px', transform: 'scale(1.08)' } }} onClick={downloadTeamsImage}>Télécharger les équipes</Button>

            </Box> */}

            <Box ref={teamRef} sx={{ display: 'flex', position: 'relative', marginTop: 2, flexDirection: { xs: 'column', md: 'row' }, gap: 2, justifyContent: 'center' }}>
                {['ally', 'enemy'].map((teamType) => {
                    const borderColor = teamType === 'ally' ? '#2596be' : '#e80616';
                    const team = teamType === 'ally' ? teamAlly : teamEnemy;
                    const setTeamName = teamType === 'ally' ? setTeamAllyName : setTeamEnemyName;
                    const teamName = teamType === 'ally' ? teamAllyName : teamEnemyName;
                    const isAlly = teamType === 'ally';
                    const isEnemy = teamType === 'enemy';
                    return (
                        <React.Fragment key={teamType}>
                            <Box sx={{ border: `solid white 2px`, backgroundColor: `${borderColor}`, borderRadius: '10px', padding: '10px', display: 'flex', justifyContent: 'center', flexDirection: 'column', }} key={teamType}>
                                <TextField
                                    value={teamName}
                                    onChange={(e) => setTeamName(e.target.value)}
                                    variant="outlined"
                                    size="small"
                                    sx={{ mb: 2, input: { color: 'white' }, backgroundColor: "rgba(255,255,255,0.2)" }}
                                    InputLabelProps={{
                                        style: { color: 'white' },
                                    }}
                                />
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'center' }}>
                                    {Object.entries(team).map(([role, heroes]) => (
                                        <Box item xs={12} sm={4} key={role}>
                                            <Typography align='center' sx={{ fontFamily: 'Kavit, sans-serif', fontWeight: 'bold', mb: 2, color: 'white', }} variant="h6">{role.charAt(0).toUpperCase() + role.slice(1)}</Typography>
                                            <Box sx={{ display: 'flex', gap: 1, }}>
                                                {heroes.map((hero, index) => (
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} key={`${hero.name}-${index}`}>
                                                        <Box onClick={() => handleRemoveHero(hero, teamType)} sx={{
                                                            cursor: 'pointer', width: { xs: '80px', md: '100px' }, borderRadius: '10px', backgroundColor: '#e1eaf5', border: 'solid white 2px',
                                                            '&:hover': { opacity: 0.5, },

                                                        }}>
                                                            <Box
                                                                component="img"
                                                                sx={{ objectFit: 'contain', borderRadius: '10px' }}
                                                                width="100%"
                                                                src={hero.portrait}
                                                                alt={hero.name}
                                                            />

                                                            <Typography align='center' sx={{ fontFamily: 'Oswald, sans-serif', fontSize: '15px', }}>
                                                                {hero.name}
                                                            </Typography>

                                                        </Box>
                                                        {teamType === 'ally' && (
                                                            <TextField
                                                                placeholder='Pseudo'
                                                                variant="outlined"
                                                                inputProps={{ style: { fontSize: '16px', fontWeight: 'bold', padding: '5px' } }}
                                                                value={hero.playerName || ''}
                                                                onChange={(e) => handlePlayerNameChange(role, index, e.target.value)}
                                                                sx={{ mt: 1, width: '120px', backgroundColor: 'white' }}
                                                            />
                                                        )}
                                                    </Box>
                                                ))}


                                            </Box>


                                        </Box>

                                    ))}

                                </Box>

                                <Box sx={{ p: 1, display: 'flex', gap: 1, mb: 2 }}>
                                    <Select
                                        value={selectedMap}
                                        onChange={handleMapChange}
                                        displayEmpty
                                        sx={{ m: 1, fontSize: '20px', width: '300px', backgroundColor: 'white' }}
                                    >
                                        <MenuItem value="">Choisir une carte</MenuItem>
                                        {maps.map((map) => (
                                            <MenuItem key={map.name} value={map.name}>{map.name}</MenuItem>
                                        ))}
                                    </Select>
                                    {/* Afficher le champ de texte pour la sous-map si la carte a un mode de jeu "control" */}
                                    {currentMap.gamemodes && currentMap.gamemodes.includes('control') && (
                                        <TextField
                                            placeholder='Sous-map'
                                            variant="outlined"
                                            inputProps={{ style: { fontSize: '20px', fontWeight: 'bold', } }}
                                            value={subMapName}
                                            onChange={(e) => setSubMapName(e.target.value)}
                                            sx={{ m: 1, backgroundColor: 'white' }}
                                        />
                                    )}
                                    {currentMap.gamemodes && (currentMap.gamemodes.includes('hybrid') || currentMap.gamemodes.includes('escort')) && (
                                        <Select
                                            value={mode}
                                            onChange={handleModeChange}
                                            displayEmpty
                                            sx={{ fontSize: '20px', m: 1, width: 120, backgroundColor: 'white' }}
                                        >
                                            <MenuItem value="">Side</MenuItem>
                                            <MenuItem value="attack">Attaque</MenuItem>
                                            <MenuItem value="defense">Défense</MenuItem>
                                        </Select>
                                    )}

                                    {/* TextField pour le point concerné si la carte est "hybrid" ou "escort" */}
                                    {mode && (
                                        <Select
                                            value={pointNumber}
                                            onChange={handlePointNumberChange}
                                            displayEmpty
                                            sx={{ fontSize: '20px', m: 1, width: 120, backgroundColor: 'white' }}
                                        >
                                            <MenuItem value="">Point</MenuItem>
                                            <MenuItem value="P1">P1</MenuItem>
                                            <MenuItem value="P2">P2</MenuItem>
                                            <MenuItem value="P3">P3</MenuItem>
                                        </Select>
                                    )}
                                </Box>

                            </Box>
                        </React.Fragment>

                    );
                })}

            </Box >



            <Box sx={{ marginTop: '50px', marginBottom: '50px', }}>

                <Typography align='center' sx={{ fontFamily: 'Kavit, sans-serif', mb: 1 }} variant="h5">Sélectionnez vos héros</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', gap: 2, justifyContent: 'center' }}>
                    {heroes.map((hero) => (
                        <Box sx={{ display: 'flex', padding: '2px', flexWrap: 'wrap', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} key={hero.name}>
                            <Box sx={{ width: '100px', borderRadius: '10px', backgroundColor: '#e1eaf5', border: 'solid white 2px' }}>
                                <Box
                                    component="img"
                                    sx={{ objectFit: 'contain', borderRadius: '10px' }}
                                    width="100%"
                                    src={hero.portrait}
                                    alt={hero.name}
                                // Ajustez la taille selon vos besoins
                                />


                                <Typography align='center' sx={{ fontFamily: 'Oswald, sans-serif', fontSize: '14px', }}>
                                    {hero.name}
                                </Typography>
                            </Box>
                            <ButtonGroup size='small' sx={{ marginTop: '10px' }} aria-label="small button group">
                                <Button sx={{ backgroundColor: 'hsl(187, 120%, 50%)', "&:hover": { backgroundColor: 'hsl(187, 120%, 50%) ', opacity: 0.5 }, color: 'white' }} onClick={() => handleSelectHero(hero, 'ally')}>Allié</Button>
                                <Button sx={{ backgroundColor: '#e80616', color: 'white', "&:hover": { backgroundColor: '#e80616', opacity: 0.5 } }} onClick={() => handleSelectHero(hero, 'enemy')}>Ennemi</Button>
                            </ButtonGroup>
                        </Box>
                    ))}
                </Box>

            </Box>
        </>
    );
}

export default Builder;

